// app/javascript/controllers/checkbox_select_all_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkboxAll", "checkbox"]

  connect() {
    this.updateCheckboxAllState()

    this.checkboxAllTarget.addEventListener("change", () => {
      this.toggleAllCheckboxes(this.checkboxAllTarget.checked)
    })

    this.checkboxTargets.forEach(checkbox => {
      checkbox.addEventListener("change", () => {
        this.updateCheckboxAllState()
      })
    })
  }

  toggleAllCheckboxes(checked) {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
  }

  updateCheckboxAllState() {
    const allChecked = this.checkboxTargets.every(checkbox => checkbox.checked)
    this.checkboxAllTarget.checked = allChecked
  }
}
